import React from "react";
import { DotLoading } from "antd-mobile";

const LoadingAxios = (props) => {
    return (
        <DotLoading color="#FDF756" />
    )
}

export default LoadingAxios;